import * as React from 'react';
import './App.css';
import { toast } from 'react-toastify';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import moment from 'moment';
import { v4 as uuidv4 } from 'uuid';
import { storeEmailPassword } from './LoginLocalStorage.js';
import AppLang from './AppLang.json';
import { CalcHelpers } from './CalcHelpers.js';

import Topbar from './common/Topbar.js';
import Login from './Login.js';
import CourtList from './CourtList.js';
import CourtMain from './CourtMain.js';
import CourtSettings from './CourtSettings.js';
import CourtStream from './CourtStream.js';
import SelectLocation from './SelectLocation.js';
import About from './About.js';

class App extends React.Component {

	constructor(props) {

		super(props);
		
		this.textSocket = null;

		this.state = {
			baseURLAPI: "https://replayapi.dbtouch.com",
			managementBaseURLAPI: "https://managementapi.plurato.com",
			dbtouch: 0,
			sessionID: "",
			userID: 0,
			email: "",
			firstName: "",
			lastName: "",
			fullName: "",
			phone: "",
			companyID: 0,
			locationListJsonObj: null,
			language: "en",
			replayAppUserType: 0,
			firstLoadYN: true,
			navbarOpenYN: false,
			locationID: 0,
			locationName: "",
			courtID: 0,
			cameraID: 0,
			refreshCourtListYN: false,
			refreshCourtMainYN: false,
			calcHelpersObj: null,
			cameraJPGArray: [],
			reactID: "",
		}
	
		this.getEURString = this.getEURString.bind(this);
		this.getDayOfWeek = this.getDayOfWeek.bind(this);
		this.getMonthString = this.getMonthString.bind(this);
		this.getMonthStringShort = this.getMonthStringShort.bind(this);
		this.getWeekdayString = this.getWeekdayString.bind(this);
		this.getWeekdayStringShort = this.getWeekdayStringShort.bind(this);
		this.handleMouseClick = this.handleMouseClick.bind(this);
		this.getFilenameAndExtFromFilenameExt = this.getFilenameAndExtFromFilenameExt.bind(this);
		this.serverGetUserDataFromSessionID = this.serverGetUserDataFromSessionID.bind(this);
		this.getSessionIDFromURLString = this.getSessionIDFromURLString.bind(this);
		this.serverUpdateUserLanguage = this.serverUpdateUserLanguage.bind(this);
		this.showToast = this.showToast.bind(this);
		this.logoutClearVariables = this.logoutClearVariables.bind(this);
		this.serverLogout = this.serverLogout.bind(this);
		this.setCompanyName = this.setCompanyName.bind(this);
		this.serverGetUserData = this.serverGetUserData.bind(this);
		this.serverDBTouchGetUserData = this.serverDBTouchGetUserData.bind(this);
		this.serverGetUserDBTouchData = this.serverGetUserDBTouchData.bind(this);
		this.setSessionID = this.setSessionID.bind(this);
		this.setUserID = this.setUserID.bind(this);
		this.setLanguage = this.setLanguage.bind(this);
		this.setNavbarOpenYN = this.setNavbarOpenYN.bind(this);
		this.getLang = this.getLang.bind(this);
		this.separateTextIntoArrayOfLines = this.separateTextIntoArrayOfLines.bind(this);
		this.convertTextNewlineToBr = this.convertTextNewlineToBr.bind(this);
		this.convertTextToJsx = this.convertTextToJsx.bind(this);
		this.getDateStringFromUnixTimeSec = this.getDateStringFromUnixTimeSec.bind(this);
		this.getTimeStringFromUnixTimeSec = this.getTimeStringFromUnixTimeSec.bind(this);
		this.getDateTimeStringFromUnixTimeSec = this.getDateTimeStringFromUnixTimeSec.bind(this);
		this.getTimeStringFromSeconds = this.getTimeStringFromSeconds.bind(this);
		this.checkIfLoggedIn = this.checkIfLoggedIn.bind(this);
		this.setSelectedLocation = this.setSelectedLocation.bind(this);
		this.setSelectedCourt = this.setSelectedCourt.bind(this);
		this.setSelectedCamera = this.setSelectedCamera.bind(this);
		this.setRefreshCourtListYN = this.setRefreshCourtListYN.bind(this);
		this.setRefreshCourtMainYN = this.setRefreshCourtMainYN.bind(this);
		this.serverGetUserSettingsData = this.serverGetUserSettingsData.bind(this);
		this.serverGetLocationList = this.serverGetLocationList.bind(this);
		this.getTwoDigits = this.getTwoDigits.bind(this);
		this.saveItemToCameraJPGArray = this.saveItemToCameraJPGArray.bind(this);
		this.socketProcessMessage = this.socketProcessMessage.bind(this);
		this.textSocketSendJsonObj = this.textSocketSendJsonObj.bind(this);
	}
	
	async componentDidMount() {

		document.title = "Replay";

		var baseURLAPI = this.state.baseURLAPI; //await this.detectBaseURLAPI();

		const unixTimeMs = Date.now();
		var reactID = unixTimeMs + "-" + uuidv4();

		var calcHelpersObj = new CalcHelpers();
		calcHelpersObj.baseURLAPI = baseURLAPI;
		this.setState({
			calcHelpersObj: calcHelpersObj,
			reactID: reactID,
		});
		
		var windowLocation = window.location;
		var windowLocationString = windowLocation.toString();
		var sessionID = this.getSessionIDFromURLString(windowLocationString);
		
		if (sessionID === "") {
			this.setState({firstLoadYN: false});
			return;
		}
		
		this.setState({
			sessionID: sessionID,
		});
		this.serverGetUserDataFromSessionID(sessionID);
	}

	componentWillUnmount() {
	}
	
	refreshCourtPages() {
		this.setRefreshCourtListYN(true);
		this.setRefreshCourtMainYN(true);
	}
	
	socketProcessMessage = (event) => {
		
		var jsonString = event.data;
		var jsonObj = null;

		try {
			jsonObj = JSON.parse(jsonString);
		} catch (err) {
		}
		if (jsonObj === null) {
			return;
		}

		var command = jsonObj.command;

		if (command === "buttonPressed") {
			var courtName = jsonObj.courtName;
			var toastText = this.getLang(AppLang, "buttonPressedOnCourt") + ': "' + courtName + '"';
			this.showToast(toastText);
			this.refreshCourtPages();
		}

		if (command === "jpgFromOnSite") {
			this.saveItemToCameraJPGArray(jsonObj);
		}
	}
	
	textSocketSendJsonObj(jsonObj) {
		
		if (jsonObj === null) {
			return;
		}

		if (this.textSocket === null) {
			return;
		}

		try {
			if (this.textSocket.readyState !== WebSocket.OPEN) {
				return;
			}

			var jsonString = JSON.stringify(jsonObj);
			this.textSocket.send(jsonString);
		} catch (err) {
		}
	}

	startWebSocketConnectionToServer(locationID) {

		var baseURLAPI = this.state.baseURLAPI;
		var companyID = this.state.companyID;
		var url = baseURLAPI + "/open?sockettype=react&companyid=" + companyID;
		url = url + "&locationid=" + locationID;
		var socket = new WebSocket(url);
		this.textSocket = socket;

		socket.onopen = () => {
			console.log("Connected to WebSocket server");
		};

		socket.onmessage = this.socketProcessMessage;

		socket.onerror = (error) => {
			console.error("WebSocket error:");
			console.error(error);
		};

		socket.onclose = () => {
			console.log("WebSocket connection closed");
			this.startWebSocketConnectionToServer(locationID)
		};
	}
	
	saveItemToCameraJPGArray(itemObj1) {

		var cameraJPGArray = this.state.cameraJPGArray;
		var i;
		var cameraID1 = itemObj1.cameraID;
		var jpgBase64 = itemObj1.jpgBase64;
		var unixTimeSec = itemObj1.unixTimeSec;
		var itemObj2;
		var cameraID2;
		var foundYN = false;

		for(i=0; i<cameraJPGArray.length; i++) {
			itemObj2 = cameraJPGArray[i];
			cameraID2 = itemObj2.cameraID;
			if (cameraID1 === cameraID2) {
				itemObj2.jpgBase64 = jpgBase64;
				itemObj2.unixTimeSec = unixTimeSec;
				foundYN = true;
			}
		}
		
		if (!foundYN) {
			itemObj2 = {
				cameraID: cameraID1,
				jpgBase64: jpgBase64,
				unixTimeSec: unixTimeSec,
			};
			cameraJPGArray.push(itemObj2);
		}
		
		this.setState({cameraJPGArray: cameraJPGArray});
	}
	
	getEURString(value, decimalPlaces) {
		
		if (value === null) {
			value = 0;
		}

		if (decimalPlaces === 0) {
			value = Math.round(value);
		} else {
			value = value.toFixed(decimalPlaces);
		}
		
		var eurString = new Intl.NumberFormat('de-DE').format(value);

		if (decimalPlaces === 2) {
			var index = eurString.indexOf(",");
			if (index === -1) {
				eurString = eurString + ",00";
			} else {
				if (index+2 === eurString.length) {
					eurString = eurString + "0";
				}
			}
		}

		eurString = eurString + " €";
		return eurString;
	}
	
	getDayOfWeek(year, month, day) {
		var dateObj = new Date(year, month-1, day, 0, 0, 0, 0);
		var dayOfWeek = dateObj.getDay();
		return dayOfWeek;
	}
	
	getMonthString(month) {
		if (month === 0) {
			return this.getLang(AppLang, "fullYear");
		}
		var monthNames = ["january", "february", "march", "april", "mayFull", "june", "july", "august", "september", "october", "november", "december"];
		var monthString = monthNames[month-1];
		var monthStringLanguage = this.getLang(AppLang, monthString);
		return monthStringLanguage;
	}
	
	getMonthStringShort(month) {
		var monthNames = ["jan", "feb", "mar", "apr", "may", "jun", "jul", "aug", "sep", "oct", "nov", "dec"];
		var monthString = monthNames[month-1];
		var monthStringLanguage = this.getLang(AppLang, monthString);
		return monthStringLanguage;
	}
	
	getWeekdayString(weekday) {
		var weekdayNames = ["sunday", "monday", "tuesday", "wednesday", "thursday", "friday", "saturday"];
		var weekdayString = weekdayNames[weekday];
		var weekdayStringLanguage = this.getLang(AppLang, weekdayString);
		return weekdayStringLanguage;
	}
	
	getWeekdayStringShort(weekday) {
		var weekdayNames = ["sun", "mon", "tue", "wed", "thu", "fri", "sat"];
		var weekdayString = weekdayNames[weekday];
		var weekdayStringLanguage = this.getLang(AppLang, weekdayString);
		return weekdayStringLanguage;
	}
	
	handleMouseClick(e) {

		var target = e.target;
		var id = target.id;
		
		if (id === "fimenu") {
			return;
		}
		
		if (id === "") {
			var parentNode = target.parentNode;
			if (parentNode !== null) {
				id = parentNode.id;
				if (id === "fimenu") {
					return;
				}
				if (id === "") {
					parentNode = parentNode.parentNode;
					if (parentNode !== null) {
						id = parentNode.id;
						if (id === "fimenu") {
							return;
						}
					}
				}
			}
		}

		this.setNavbarOpenYN(false);		
	}

	getFilenameAndExtFromFilenameExt(filenameExt) {
		var length = filenameExt.length;
		var ext = filenameExt.split('.').pop();
		var filename = filenameExt.substring(0, length - ext.length - 1);
		ext = ext.toLowerCase();
		return [filename, ext];
	}
	
	async serverGetUserDataFromSessionID(sessionID) {
		
		var managementBaseURLAPI = this.state.managementBaseURLAPI;
		var url = managementBaseURLAPI + "/getuserdatafromsessionid?sid=" + sessionID;

		try {
			const res = await fetch(url);
			const jsonObj = await res.json();

			var userID = jsonObj.userID;
			var email = jsonObj.email;
			var firstName = jsonObj.firstName;
			var lastName = jsonObj.lastName;
			var phone = jsonObj.phone;
			var language = jsonObj.language;
			var replayAppUserType = 0;
			var companyID = jsonObj.companyID;
			var createdTimestamp = jsonObj.createdTimestamp;

			var fullName = firstName + " " + lastName;
			fullName = fullName.trim();
			if (fullName === "") {
				fullName = email;
			}

			this.setState({
				userID: userID,
				email: email,
				firstName: firstName,
				lastName: lastName,
				fullName: fullName,
				phone: phone,
				language: language,
				replayAppUserType: replayAppUserType,
				companyID: companyID,
				createdTimestamp: createdTimestamp,
				firstLoadYN: false,
			});

			this.setCompanyName(companyID);
			this.serverGetUserSettingsData(userID, fullName);			
		} catch (e) {
			this.setState({firstLoadYN: false});
		}
	}
	
	getSessionIDFromURLString(urlString) {

		var i;
		var index;
		var length;
		var foundYN;
		var sessionID = "";
		
		length = urlString.length;
		foundYN = false;
		index = 0;
		
		// find sid=
		for(i=0; (i<length) && (!foundYN); i++) {
			if (urlString.substr(i, 4) === "sid=") {
				foundYN = true;
				index = i+4;
			}
		}
		
		if (!foundYN) {
			return "";
		}
		
		sessionID = urlString.substr(index, length-index);
		return sessionID;
	}
	
	async serverUpdateUserLanguage(userID, language) {

		var managementBaseURLAPI = this.state.managementBaseURLAPI;
		var dbtouch = this.state.dbtouch;
		var email = this.state.email; 
		var url;

		if (dbtouch) {
			url = managementBaseURLAPI + "/updateuserdbtouchlanguage?email=" + encodeURIComponent(email) + "&language=" + language;
		} else {
			url = managementBaseURLAPI + "/updateuserlanguage?userid=" + userID + "&language=" + language;
		}
		
		const res = await fetch(url);
		await res.text();
	}

	showToast(messageText) {
		toast(messageText, {
			position: "top-center",
			autoClose: 2500,
			hideProgressBar: true,
			closeOnClick: true,
			pauseOnHover: true,
			draggable: true,
		});
	}
	
	logoutClearVariables() {
		
		var sessionID = this.state.sessionID;
		this.serverLogout(sessionID);

		this.setState({
			sessionID: "",
			userID: 0,
			email: "",
			firstName: "",
			lastName: "",
			fullName: "",
			phone: "",
			replayAppUserType: 0,
			companyID: 0,
			createdTimestamp: "",
		});
		
		storeEmailPassword("", "");
	}

	async serverLogout(sessionID) {
		
		var managementBaseURLAPI = this.state.managementBaseURLAPI;
		var url = managementBaseURLAPI + "/logout?sid=" + sessionID;

		const res = await fetch(url);
		await res.text();
	}

	async serverGetUserData(userID) {

		if (userID <= 0) {
			return;
		}

		var sessionID = this.state.sessionID;
		var managementBaseURLAPI = this.state.managementBaseURLAPI;
		var url = managementBaseURLAPI + "/getuserdata?sid=" + sessionID + "&userid=" + userID;
		
		const res = await fetch(url);
		const jsonObj = await res.json();

		var email = jsonObj.email;
		var firstName = jsonObj.firstName;
		var lastName = jsonObj.lastName;
		var phone = jsonObj.phone;
		var language = jsonObj.language;
		var replayAppUserType = 0;
		var companyID = jsonObj.companyID;
		var createdTimestamp = jsonObj.createdTimestamp;

		var fullName = firstName + " " + lastName;
		fullName = fullName.trim();
		if (fullName === "") {
			fullName = email;
		}

		this.setState({
			email: email,
			firstName: firstName,
			lastName: lastName,
			fullName: fullName,
			phone: phone,
			language: language,
			replayAppUserType: replayAppUserType,
			companyID: companyID,
			createdTimestamp: createdTimestamp,
		});
		
		this.setCompanyName(companyID);
		this.serverGetUserSettingsData(userID, fullName);			
	}
	
	async serverDBTouchGetUserData(userID) {

		if (userID <= 0) {
			return;
		}

		var managementBaseURLAPI = this.state.managementBaseURLAPI;
		var url = managementBaseURLAPI + "/dbtouchGetUserData?userid=" + userID;

		const res = await fetch(url);
		const jsonObj = await res.json();

		var isActive = jsonObj.isActive;
		if (!isActive) {
			this.logoutClearVariables();
			return;
		}

		var email = jsonObj.username;
		var firstName = jsonObj.firstName;
		var lastName = jsonObj.lastName;
		var companyID = jsonObj.companyId;
		
		var fullName = firstName + " " + lastName;
		fullName = fullName.trim();
		if (fullName === "") {
			fullName = email;
		}

		this.setState({
			dbtouch: 1,
			email: email,
			firstName: firstName,
			lastName: lastName,
			fullName: fullName,
			companyID: companyID,
		});
		
		this.serverGetUserDBTouchData(companyID, email);
		//this.serverDBTouchSetCompanyName(companyID);
		this.serverGetUserSettingsData(userID, fullName);
	}
	
	async serverGetUserDBTouchData(companyID, email) {

		var managementBaseURLAPI = this.state.managementBaseURLAPI;
		var url = managementBaseURLAPI + "/getuserdbtouchdata?email=" + encodeURIComponent(email);

		const res = await fetch(url);
		var responseText = await res.text();
		if (responseText === "") {
			return;
		}
		
		var jsonObj = JSON.parse(responseText);

		var language = jsonObj.language;
		var replayAppUserType = jsonObj.replayAppUserType;

		this.serverGetLocationList(companyID);

		/*if (replayAppUserType < 1) {
			storeEmailPassword("", "");
			this.showToast("You do not have permission to use this app.");
			setTimeout(function () {
				window.location.href = "/login";
			}, 1000);
			return;
		}*/
		
		this.setState({
			language: language,
			replayAppUserType: replayAppUserType,
		});
}

	async setCompanyName(companyID) {

		var managementBaseURLAPI = this.state.managementBaseURLAPI;
		var url = managementBaseURLAPI + "/getcompanydata?companyid=" + companyID;

		const res = await fetch(url);
		const jsonObj = await res.json();

		var companyName = jsonObj.companyName;
		this.setState({companyName: companyName});
	}
	
	setSessionID(sessionID) {
		this.setState({sessionID: sessionID});
	}
	
	setUserID(userID) {
		this.setState({userID: userID});
	}
	
	setLanguage(language) {
		var userID = this.state.userID;
		this.serverUpdateUserLanguage(userID, language);
		this.setState({language: language});
	}
	
	setNavbarOpenYN(navbarOpenYN) {
		this.setState({
			navbarOpenYN: navbarOpenYN,
		});
	}
	
	getLang(lang, id) {
		var language = this.state.language;
		var id2 = id + "." + language;
		var i;
		var id3;
		var length = lang.length;
		var itemObj;
		var keys;
		var returnString;
		for(i=0; i<length; i++) {
			itemObj = lang[i];
			keys = Object.keys(itemObj);
			id3 = keys[0];
			if (id2 === id3) {
				returnString = itemObj[id2];
				return returnString;
			}
		}
		return "";
	}
	
	separateTextIntoArrayOfLines(inputText) {

		var lineArray = [];

		if (inputText === null) {
			inputText = "";
		}

		if (inputText === "") {
			return lineArray;
		}

		var i;
		var ch;
		var len = inputText.length;
		var oneLineText = "";
		
		for(i=0; i<len; i++) {
			ch = inputText[i];
			if (ch === "\n") {
				lineArray.push(oneLineText);
				oneLineText = "";
			} else {
				if (ch !== "\r") {
					oneLineText = oneLineText + ch;
				}
			}
		}
		
		lineArray.push(oneLineText);

		return lineArray;
	}

	convertTextNewlineToBr(inputText, variable, className) {
		
		var lineArray = this.separateTextIntoArrayOfLines(inputText);
		var jsxArray = [];
		
		var i;
		var len = lineArray.length;
		var oneLineText;
		var key;
		
		for(i=0; i<len; i++) {
			key = variable + "-" + i;
			oneLineText = lineArray[i];
			if (oneLineText === "") {
				jsxArray.push(<div key={key} style={{height: "10px"}}></div>);
			} else {
				jsxArray.push(<div key={key} className={className}>{oneLineText}</div>);
			}
		}
		
		return (<div>{jsxArray}</div>);
	}
	
	convertDoubleStarToBold(variable, index, text1) {

		var i;
		var ch1;
		var ch2;
		var doubleStarYN;
		var boldStartedYN = false;
		var jsxCode;
		var jsxArray = [];
		var text2 = "";
		var key;
		
		i = 0;
		while (i<text1.length) {

			ch1 = text1[i];
			if (i >= text1.length-1) {
				ch2 = " ";
			} else {
				ch2 = text1[i+1];
			}
			doubleStarYN = false;
			if ((ch1 === "*") && (ch2 === "*")) {
				doubleStarYN = true;
			}
			
			if (doubleStarYN) {
				if (boldStartedYN) {
					key = variable + "-" + index + "-" + i;
					jsxCode = (<b key={key}>{text2}</b>);
					jsxArray.push(jsxCode);
					boldStartedYN = false;
					text2 = "";
				} else {
					key = variable + "-" + index + "-" + i;
					jsxCode = (<span key={key}>{text2}</span>);
					jsxArray.push(jsxCode);
					text2 = "";
					boldStartedYN = true;
				}
				i += 2;
			} else {
				text2 = text2 + ch1;
				i ++;
			}
		}

		key = variable + "-" + index + "-" + i;
		jsxCode = (<span key={key}>{text2}</span>);
		jsxArray.push(jsxCode);
		
		return jsxArray;
	}

	convertTextToJsx(inputText, variable, className) {
		
		var lineArray = this.separateTextIntoArrayOfLines(inputText);
		var jsxArray = [];
		
		var i;
		var len = lineArray.length;
		var oneLineText;
		var jsxCode;
		var key;
		
		for(i=0; i<len; i++) {
			key = variable + "-" + i;
			oneLineText = lineArray[i];
			if (oneLineText === "") {
				jsxArray.push(<div key={key} style={{height: "10px"}}></div>);
			} else {
				jsxCode = this.convertDoubleStarToBold(variable, i, oneLineText);
				jsxArray.push(<div key={key} className={className}>{jsxCode}</div>);
			}
		}
		
		return (<div>{jsxArray}</div>);
	}

	getDateStringFromUnixTimeSec(unixTimeSec) {

		if (unixTimeSec === null) {
			unixTimeSec = 0;
		}
		
		if (unixTimeSec === 0) {
			return "";
		}

		var dateObj = new Date(unixTimeSec * 1000);

		var dateString = moment(dateObj).format('DD.MM.YYYY');
		return dateString;
	}

	getTimeStringFromUnixTimeSec(unixTimeSec) {

		if (unixTimeSec === null) {
			unixTimeSec = 0;
		}
		
		if (unixTimeSec === 0) {
			return "";
		}

		var dateObj = new Date(unixTimeSec * 1000);

		var timeString = moment(dateObj).format('HH:mm:ss');
		return timeString;
	}

	getDateTimeStringFromUnixTimeSec(unixTimeSec) {

		if (unixTimeSec === null) {
			unixTimeSec = 0;
		}
		
		if (unixTimeSec === 0) {
			return "";
		}

		var currentDateObj = new Date();
		var dateObj = new Date(unixTimeSec * 1000);
		
		var year1 = currentDateObj.getFullYear();
		var year2 = dateObj.getFullYear();
		
		var dateTimeString;
		if (year1 === year2) {
			dateTimeString = moment(dateObj).format('DD/MM HH:mm');
		} else {
			dateTimeString = moment(dateObj).format('DD.MM.YYYY HH:mm');
		}

		return dateTimeString;
	}

	getTimeStringFromSeconds(seconds) {
		
		if (seconds === null) {
			return "";
		}

		var secondsLeft = 0;
		var hours = 0;
		var minutes = 0;
		var timeString = "";
		
		secondsLeft = seconds;
		
		hours = Math.floor(secondsLeft / 3600);
		secondsLeft = secondsLeft - hours * 3600;
		
		minutes = Math.floor(secondsLeft / 60);
		secondsLeft = secondsLeft - minutes * 60;
		
		if (hours > 0) {
			timeString = hours + "h ";
		}
		
		if (minutes > 0) {
			timeString = timeString + minutes + "m ";
		}
		
		if ((hours === 0) && (minutes === 0)) {
			timeString = timeString + secondsLeft + "s";
		}

		return timeString;
	}
	
	checkIfLoggedIn() {
				
		var pathname = window.location.pathname;
		
		if (pathname === "/") {
			return;
		}

		var userID = this.state.userID;
		if (userID !== 0) {
			return;
		}
		
		var url = "/";
		window.location.href = url;
	}
	
	async serverGetLocationData(locationID) {
		
		if (locationID <= 0) {
			return null;
		}

		var baseURLAPI = this.state.baseURLAPI;
		var url = baseURLAPI + "/getlocationdata?locationid=" + locationID;
		
		var locationJsonObj = null;
		
		try {
			var res = await fetch(url);
			locationJsonObj = await res.json();
		} catch (err) {
			console.error(err);
		}

		return locationJsonObj;
	}
	
	async serverDownloadTextFile(url) {
		
		var responseText = "";
		
		try {
			var res = await fetch(url);
			var responseStatus = res.status;
			if (responseStatus === 200) {
				responseText = await res.text();
			}
		} catch (err) {
			console.error(err);
		}

		return responseText;
	}
	
	setDocType(docType) {
		this.setState({
			docType: docType,
		});
	}
	
	async setSelectedLocation(locationID) {

		var locationName = "";
		var jsonObj1 = await this.serverGetLocationData(locationID);
		if (jsonObj1 !== null) {
			locationName = jsonObj1.locationName;
		}

		this.setState({
			locationID: locationID,
			locationName: locationName,
		});

		var jsonObj2 = {
			command: "setLocation",
			locationID: locationID,
		}

		this.textSocketSendJsonObj(jsonObj2);
	}
	
	setSelectedCourt(courtID) {
		this.setState({
			courtID: courtID,
		});
	}
	
	setSelectedCamera(cameraID) {
		this.setState({
			cameraID: cameraID,
		});
	}
	
	setRefreshCourtListYN(refreshCourtListYN) {
		this.setState({
			refreshCourtListYN: refreshCourtListYN,
		});
	}

	setRefreshCourtMainYN(refreshCourtMainYN) {
		this.setState({
			refreshCourtMainYN: refreshCourtMainYN,
		});
	}

	async serverStorageProxy(storageID, filename) {

		var dateObj = new Date();
		var randNumber = dateObj.getTime();
		var baseURLAPI = this.state.baseURLAPI;
		var url = baseURLAPI + "/storageproxy?storageid=" + encodeURIComponent(storageID);
		url = url + "&filename=" + encodeURIComponent(filename);
		url = url + "&r=" + randNumber;

		var responseText = "";
		
		try {
			var res = await fetch(url);
			responseText = await res.text();
		} catch (err) {
			console.error(err);
		}

		return responseText;
	}
		
	async serverGetUserSettingsData(userID, userFullName) {

		if (userID <= 0) {
			return null;
		}

		var baseURLAPI = this.state.baseURLAPI;
		var url = baseURLAPI + "/getusersettingsdata?userid=" + userID;
		url = url + "&userfullname=" + encodeURIComponent(userFullName);
		
		var userSettingsJsonObj = null;
		
		try {
			var res = await fetch(url);
			userSettingsJsonObj = await res.json();
		} catch (err) {
		}

		if (userSettingsJsonObj === null) {
			return;
		}

		this.setState({
			userSettingsJsonObj: userSettingsJsonObj,
		});
		
		var locationID = userSettingsJsonObj.locationID;
		this.setSelectedLocation(locationID);
		this.startWebSocketConnectionToServer(locationID);
	}
	
	async serverGetLocationList(companyID) {
		
		var locationListJsonObj2 = [];

		var baseURLAPI = this.state.baseURLAPI;
		var url = baseURLAPI + "/getlocationlist?companyid=" + companyID;

		var res = await fetch(url);
		var locationListJsonObj = await res.json();
		
		this.setState({
			locationListJsonObj: locationListJsonObj,
		});
	}
	
	getTwoDigits(number1) {
		var number2;
		number2 = number1;
		if (number1 < 10) {
			number2 = "0" + number1;
		}
		return number2;
	}

	render() {
		
		this.checkIfLoggedIn();
		
		var firstLoadYN = this.state.firstLoadYN;
		if (firstLoadYN) {
			return null;
		}
		
		var loggedInYN;
		var userID = this.state.userID;
		
		if (userID === 0) {
			loggedInYN = false;
		} else {
			loggedInYN = true;
		}

		var replayAppUserType = this.state.replayAppUserType;
		if (loggedInYN) {
			if (replayAppUserType < 1) {
				//return null;
			}
		}

		return (
		<Router>
			<div className="App" onClick={this.handleMouseClick}>
				<ToastContainer />
				<Topbar 
					userID={this.state.userID}
					email={this.state.email}
					firstName={this.state.firstName}
					lastName={this.state.lastName}
					sessionID={this.state.sessionID}
					appUserType={this.state.replayAppUserType}
					navbarOpenYN={this.state.navbarOpenYN}
					iconName="REPLAY"
					appName="REPLAY"
					bkColor1="#0a1936"
					logoutClearVariables={this.logoutClearVariables}
					setLanguage={this.setLanguage}
					getLang={this.getLang}
					setNavbarOpenYN={this.setNavbarOpenYN}
				/>
        		<Routes>
          			<Route 
						path="/"
						element={
							<div>
							{!loggedInYN && (
								<Login
									managementBaseURLAPI={this.state.managementBaseURLAPI}
									setSessionID={this.setSessionID}
									setUserID={this.setUserID}
									serverGetUserData={this.serverGetUserData}
									serverDBTouchGetUserData={this.serverDBTouchGetUserData}
									getLang={this.getLang}
								/>
							)}
							{loggedInYN && (
								<CourtList
									baseURLAPI={this.state.baseURLAPI}
									userID={this.state.userID}
									email={this.state.email}
									fullName={this.state.fullName}
									companyID={this.state.companyID}
									replayAppUserType={this.state.replayAppUserType}
									locationID={this.state.locationID}
									locationName={this.state.locationName}
									refreshCourtListYN={this.state.refreshCourtListYN}
									cameraJPGArray={this.state.cameraJPGArray}
									showToast={this.showToast}
									getLang={this.getLang}
									getDateStringFromUnixTimeSec={this.getDateStringFromUnixTimeSec}
									getTimeStringFromUnixTimeSec={this.getTimeStringFromUnixTimeSec}
									setSelectedCourt={this.setSelectedCourt}
									setSelectedCamera={this.setSelectedCamera}
									setRefreshCourtListYN={this.setRefreshCourtListYN}
								/>
							)}
							</div>
						}
					/>
          			<Route 
						path="/login"
						element={
							<Login
								managementBaseURLAPI={this.state.managementBaseURLAPI}
								setSessionID={this.setSessionID}
								setUserID={this.setUserID}
								serverGetUserData={this.serverGetUserData}
								serverDBTouchGetUserData={this.serverDBTouchGetUserData}
								getLang={this.getLang}
							/>
						}
					/>
         			<Route 
						path="/courts"
						element={
							<CourtList
								baseURLAPI={this.state.baseURLAPI}
								userID={this.state.userID}
								email={this.state.email}
								fullName={this.state.fullName}
								companyID={this.state.companyID}
								replayAppUserType={this.state.replayAppUserType}
								locationID={this.state.locationID}
								locationName={this.state.locationName}
								refreshCourtListYN={this.state.refreshCourtListYN}
								cameraJPGArray={this.state.cameraJPGArray}
								showToast={this.showToast}
								getLang={this.getLang}
								getDateStringFromUnixTimeSec={this.getDateStringFromUnixTimeSec}
								getTimeStringFromUnixTimeSec={this.getTimeStringFromUnixTimeSec}
								setSelectedCourt={this.setSelectedCourt}
								setSelectedCamera={this.setSelectedCamera}
								setRefreshCourtListYN={this.setRefreshCourtListYN}
							/>
						}
					/>
         			<Route 
						path="/court"
						element={
							<CourtMain
								baseURLAPI={this.state.baseURLAPI}
								language={this.state.language}
								userID={this.state.userID}
								fullName={this.state.fullName}
								companyID={this.state.companyID}
								replayAppUserType={this.state.replayAppUserType}
								courtID={this.state.courtID}
								locationID={this.state.locationID}
								locationName={this.state.locationName}
								sourceIndex={this.state.sourceIndex}
								refreshCourtMainYN={this.state.refreshCourtMainYN}
								showToast={this.showToast}
								getLang={this.getLang}
								getDateStringFromUnixTimeSec={this.getDateStringFromUnixTimeSec}
								getTimeStringFromUnixTimeSec={this.getTimeStringFromUnixTimeSec}
								serverDownloadTextFile={this.serverDownloadTextFile}
								setRefreshCourtMainYN={this.setRefreshCourtMainYN}
							/>
						}
					/>
         			<Route 
						path="/courtsettings"
						element={
							<CourtSettings
								baseURLAPI={this.state.baseURLAPI}
								language={this.state.language}
								userID={this.state.userID}
								fullName={this.state.fullName}
								companyID={this.state.companyID}
								replayAppUserType={this.state.replayAppUserType}
								courtID={this.state.courtID}
								cameraID={this.state.cameraID}
								locationID={this.state.locationID}
								locationName={this.state.locationName}
								sourceIndex={this.state.sourceIndex}
								refreshCourtMainYN={this.state.refreshCourtMainYN}
								reactID={this.state.reactID}
								showToast={this.showToast}
								getLang={this.getLang}
								getDateStringFromUnixTimeSec={this.getDateStringFromUnixTimeSec}
								getTimeStringFromUnixTimeSec={this.getTimeStringFromUnixTimeSec}
								serverDownloadTextFile={this.serverDownloadTextFile}
								setRefreshCourtMainYN={this.setRefreshCourtMainYN}
								textSocketSendJsonObj={this.textSocketSendJsonObj}
							/>
						}
					/>
         			<Route 
						path="/stream"
						element={
							<CourtStream
								baseURLAPI={this.state.baseURLAPI}
								language={this.state.language}
								userID={this.state.userID}
								fullName={this.state.fullName}
								companyID={this.state.companyID}
								replayAppUserType={this.state.replayAppUserType}
								courtID={this.state.courtID}
								cameraID={this.state.cameraID}
								locationID={this.state.locationID}
								locationName={this.state.locationName}
								sourceIndex={this.state.sourceIndex}
								refreshCourtMainYN={this.state.refreshCourtMainYN}
								reactID={this.state.reactID}
								showToast={this.showToast}
								getLang={this.getLang}
								getDateStringFromUnixTimeSec={this.getDateStringFromUnixTimeSec}
								getTimeStringFromUnixTimeSec={this.getTimeStringFromUnixTimeSec}
								serverDownloadTextFile={this.serverDownloadTextFile}
								setRefreshCourtMainYN={this.setRefreshCourtMainYN}
								textSocketSendJsonObj={this.textSocketSendJsonObj}
							/>
						}
					/>
         			<Route 
						path="/selectlocation"
						element={
							<SelectLocation
								baseURLAPI={this.state.baseURLAPI}
								language={this.state.language}
								userID={this.state.userID}
								fullName={this.state.fullName}
								companyID={this.state.companyID}
								replayAppUserType={this.state.replayAppUserType}
								locationListJsonObj={this.state.locationListJsonObj}
								showToast={this.showToast}
								getLang={this.getLang}
								setSelectedLocation={this.setSelectedLocation}
							/>
						}
					/>
          			<Route 
						path="/about"
						element={
							<About
								baseURLAPI={this.state.baseURLAPI}
								getLang={this.getLang}
							/>
						}
          			/>
        		</Routes>
			</div>
    		</Router>
		);
	}
}

export default App;


